import React, { useEffect } from "react";
import {useNavigate} from"react-router-dom"
import store, { clearAllState } from '../../store';
import {LogOutUser}  from '../../API/auth';
function Logout () {
    let navigate = useNavigate();
    useEffect(()=>{
        let logOoutAPI = async () => {
            const token = localStorage.getItem('token');
            localStorage.clear();
            store.dispatch(clearAllState());
            let formData = {
                token: token
            }
            let res = await LogOutUser(formData);
                window.location.href = '/'

        }
        logOoutAPI();
        // navigate('/');
    }, [])
    return true;

}
export default Logout